import { render } from "./CustomTs5.vue?vue&type=template&id=674e4a9e&scoped=true"
import script from "./CustomTs5.vue?vue&type=script&lang=js"
export * from "./CustomTs5.vue?vue&type=script&lang=js"

import "./CustomTs5.vue?vue&type=style&index=0&id=674e4a9e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674e4a9e"]])

export default __exports__